import classNames from 'classnames';
import React from 'react';
import EfImg from '../ef-img';
import './index.scss';

interface EfCardsAppBItemProps {
    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 主标题
     */
    title?: string;
    /**
     * 描述
     */
    desc?: string;
}
interface EfCardsAppBProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * type 展示方式
     */
    type?: 'default' | 'noneOver';
    /**
     * 列表
     */
    list: EfCardsAppBItemProps[];
}

/**
 * 维护:谢保林
 *
 * 卡片列表
 */
const EfCardsAppB: React.FC<EfCardsAppBProps> = ({ list = [], className, type }) => {
    const prefixCls = `ef-cards-app-b`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
        [`${prefixCls}-${type}`]: type,
    });

    return (
        <div className={classes}>
            {list?.map((item: EfCardsAppBItemProps, index: number) => {
                return (
                    <div key={index} className={`${prefixCls}-item ${prefixCls}-item-${index + 1}`}>
                        <div className={`${prefixCls}-item-msg`}>
                            {item.title && <div className={`${prefixCls}-item-title`}>{item.title}</div>}
                            {item.desc && <div className={`${prefixCls}-item-desc`}>{item.desc}</div>}
                        </div>
                        <div className={`${prefixCls}-item-img`}>
                            <EfImg pc={item.pc} h5={item.h5} />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default EfCardsAppB;
